const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')
const moduleRoute = {
  path: '/dk',
  component: Module,
  children: [
    {
      path: '/',
      name: 'dk',
      component: Home,
    },
  ],
  permissions: ['employee', 'rester_employee', 'dk_operator', 'dk_manager'],
}

export default router => {
  router.addRoutes([moduleRoute])
}
